import { TagifyHTMLInputElement, TagifyTagType } from '../types/tagify';
import { validateValidationMethod } from './acme-add-domain-form';
import { MemberAreaModalHTMLElement } from './member-area-modal';

export function initAcmeEditDomainForm(): void {
    document.addEventListener('click', e => {
        const $targetEl = e.target as HTMLElement;

        if ($targetEl.classList.contains('js-edit-domain-button') ||
            $targetEl.closest('.js-edit-domain-button')
        ) {
            e.preventDefault();

            const $target = ($targetEl.classList.contains('js-edit-domain-button')
                ? $targetEl
                : $targetEl.closest('.js-edit-domain-button')) as HTMLElement;

            const modalId = $target.dataset.memberAreaModalTarget as string;
            const $modal = document.getElementById(modalId) as MemberAreaModalHTMLElement;

            const domainRefExt = $target.dataset.domain;
            const domainName = $target.dataset.domainName;
            const validationMethod = $target.dataset.validationMethod;
            const externalAccountsRefExt = JSON.parse($target.dataset.externalAccounts ?? '[]');

            if ($modal && domainRefExt && domainName && validationMethod && externalAccountsRefExt) {
                new AcmeEditDomainForm(domainRefExt, domainName, validationMethod, externalAccountsRefExt, $modal);
            }
        }
    });
}

type ModalType = {
    $el: MemberAreaModalHTMLElement,
    $refExtField: HTMLInputElement,
    $domainField: HTMLInputElement,
    $externalAccountsField: TagifyHTMLInputElement,
    $validationMethodField: HTMLSelectElement,
};

class AcmeEditDomainForm {
    domainRefExt: string;
    domainName: string;
    validationMethod: string;
    externalAccountsRefExt: string[];
    $modal: ModalType;

    constructor(
        domainRefExt: string,
        domainName: string,
        validationMethod: string,
        externalAccountsRefExt: string[],
        $modal: MemberAreaModalHTMLElement,
    ) {
        this.domainRefExt = domainRefExt;
        this.domainName = domainName;
        this.validationMethod = validationMethod;
        this.externalAccountsRefExt = externalAccountsRefExt;
        this.$modal = {
            $el: $modal,
            $refExtField: $modal.querySelector('.js-edit-domain-ref-ext-input') as HTMLInputElement,
            $domainField: $modal.querySelector('.js-edit-domain-name-input') as HTMLInputElement,
            $externalAccountsField: $modal.querySelector('.js-edit-domain-external-accounts-input') as TagifyHTMLInputElement,
            $validationMethodField: $modal.querySelector('.js-edit-domain-validation-method-input') as HTMLSelectElement,
        };

        this.$modal.$el.open();

        this.$modal.$refExtField.value = this.domainRefExt;
        this.$modal.$domainField.value = this.domainName;
        this.$modal.$validationMethodField.value = this.validationMethod;
        this.$modal.$externalAccountsField.__tagify.removeAllTags();
        this.$modal.$externalAccountsField.__tagify.whitelist.forEach((tag: TagifyTagType) => {
            if (this.externalAccountsRefExt.includes(tag.refext)) {
                this.$modal.$externalAccountsField.__tagify.addTags([tag]);
            }
        });

        validateValidationMethod(this.$modal.$domainField, this.$modal.$validationMethodField);
    }
}
